import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import Cookies from "js-cookie"
Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  loginUser: [],
  islogin: false,
}

const mutations = {
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set(state, [variable, value]) {
    state[variable] = value
  },
  updateAuth(state, user) {
    state.loginUser = user.loginUser;
    state.islogin = user.islogin;
  }
}

const actions = {
  auth(context, user) {
    context.commit('updateAuth', user);
  }
}

const options = {
  reducer: state => ({
    loginUser: state.loginUser,
    islogin: state.islogin
  }),
  key: 'BO',
  storage: {
    getItem: key => Cookies.get(key),
    setItem: (key, value) => Cookies.set(key, value, { sameSite: 'strict', secure: true }),
    removeItem: key => Cookies.remove(key)
  }
}


export default new Vuex.Store({
  state,
  mutations,
  actions,
  plugins: [createPersistedState(options)]
})